var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex"},[_c('contact-tel',{attrs:{"tel":_vm.tel}}),_c('contact-mail',{staticClass:"ml-2",attrs:{"mail":_vm.mail}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }